<template>
  <div class="info">
    <h2>{{ orgName }}</h2>
    <h3>{{ year }}年 - {{ scoreName }}</h3>
  </div>
</template>

<script>
import {getInfo} from "@/api/expert";

export default {
  name: "pageTitleModular",
  data() {
    return {
      orgName: '',
      scoreName: '',
      year: ''
    }
  },
  props: {
    orgId: {
      type: Number,
    },
    scoreId: {
      type: Number,
    }
  },
  created() {
    this.getInfo()
  },
  components: {},
  methods: {
    async getInfo() {
      const res = await getInfo(this.orgId, this.scoreId)
      this.orgName = res.data.org_name
      this.scoreName = res.data.play_name
      this.year = res.data.year
    }
  },
  filters: {},
  watch: {},
}
</script>

<style scoped lang="scss">
.info{
  margin-bottom: 20px;
  h2{
    font-size: 18px;
    line-height: 150%;
    margin-bottom: 10px;
  }
  h3{
    font-size: 16px;
    line-height: 150%;
    color: #368ad1;
    margin-bottom: 10px;
  }
}
</style>
